import Vue from "vue";
import Router from "vue-router";

import { AuthModule } from "@/store/modules/auth";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/redirect",
      component: () =>
        import(
          /* webpackChunkName: "sys-monitor.redirect" */ "./views/Redirect.vue"
        ),
      children: [
        {
          path: "managed-node/:boardId/:networkId/:managedNodeId",
          component: () =>
            import(
              /* webpackChunkName: "sys-monitor.redirect.managed-node" */ "./views/redirect/ManagedNode.vue"
            ),
        },
      ],
    },
    {
      path: "/",
      component: () =>
        import(/* webpackChunkName: "frame" */ "./views/Frame.vue"),
      meta: { requiresAuth: true },
      children: [
        {
          path: "",
          redirect: "/home",
        },
        {
          path: "home",
          component: () =>
            import(/* webpackChunkName: "home" */ "./views/Home.vue"),
        },
        {
          path: "security",
          component: () =>
            import(
              /* webpackChunkName: "security.frame" */ "./views/security/Frame.vue"
            ),
          children: [
            {
              path: "",
              redirect: "/security/top",
            },
            {
              path: "top",
              component: () =>
                import(
                  /* webpackChunkName: "security.top" */ "./views/security/Top.vue"
                ),
            },
          ],
        },
        {
          path: "net-finder",
          component: () =>
            import(
              /* webpackChunkName: "net-finder.frame" */ "./views/net-finder/Frame.vue"
            ),
          children: [
            {
              path: "",
              redirect: "/net-finder/dashboard",
            },
            {
              path: "dashboard",
              component: () =>
                import(
                  /* webpackChunkName: "dashboard" */ "./views/Dashboard.vue"
                ),
            },
            {
              path: "dashboard/cloud-vm",
              component: () =>
                import(
                  /* webpackChunkName: "dashboard-vm" */ "./views/net-finder/cloud/DashboardVM.vue"
                ),
            },
            {
              path: "dashboard/cloud-vm/:environmentId/:instanceId",
              component: () =>
                import(
                  /* webpackChunkName: "dashboard-vm.cloud-instance" */ "./views/net-finder/cloud/CloudInstance.vue"
                ),
            },
            {
              path: "network",
              component: () =>
                import(
                  /* webpackChunkName: "net-finder.network" */ "./views/net-finder/Network.vue"
                ),
            },
            {
              path: "create-network",
              component: () =>
                import(
                  /* webpackChunkName: "net-finder.create-network" */ "./views/net-finder/CreateNetwork.vue"
                ),
            },
            {
              path: "network/:networkId",
              component: () =>
                import(
                  /* webpackChunkName: "net-finder.network.frame" */ "./views/net-finder/network/Frame.vue"
                ),
              children: [
                {
                  path: "",
                  component: () =>
                    import(
                      /* webpackChunkName: "net-finder.network.top" */ "./views/net-finder/network/Top.vue"
                    ),
                },
                {
                  path: "scan",
                  component: () =>
                    import(
                      /* webpackChunkName: "net-finder.network.scan" */ "./views/net-finder/network/Scan.vue"
                    ),
                },
                {
                  path: "task-schedule",
                  component: () =>
                    import(
                      /* webpackChunkName: "net-finder.network.task-schedule" */ "./views/net-finder/network/TaskSchedule.vue"
                    ),
                },
                {
                  path: "task-schedule/:taskScheduleId",
                  component: () =>
                    import(
                      /* webpackChunkName: "net-finder.network.task-schedule-edit" */ "./views/net-finder/network/TaskScheduleEdit.vue"
                    ),
                },
                {
                  path: "config",
                  component: () =>
                    import(
                      /* webpackChunkName: "net-finder.network.config" */ "./views/net-finder/network/Config.vue"
                    ),
                },
                {
                  path: "managed-node",
                  component: () =>
                    import(
                      /* webpackChunkName: "net-finder.network.managed-node" */ "./views/net-finder/network/ManagedNode.vue"
                    ),
                },
                {
                  path: "managed-node/:managedNodeId",
                  component: () =>
                    import(
                      /* webpackChunkName: "net-finder.network.managed-node-top" */ "./views/net-finder/network/ManagedNodeTop.vue"
                    ),
                },
                {
                  path: "managed-node/:managedNodeId/snapshot",
                  component: () =>
                    import(
                      /* webpackChunkName: "net-finder.network.managed-node-snapshot" */ "./views/net-finder/network/ManagedNodeSnapshot.vue"
                    ),
                },
                {
                  path: "managed-node/:managedNodeId/package",
                  component: () =>
                    import(
                      /* webpackChunkName: "net-finder.network.managed-node-package" */ "./views/net-finder/network/ManagedNodePackage.vue"
                    ),
                },
                {
                  path: "managed-node/:managedNodeId/windows-update",
                  component: () =>
                    import(
                      /* webpackChunkName: "net-finder.network.managed-node-windows-update" */ "./views/net-finder/network/ManagedNodeWindowsUpdate.vue"
                    ),
                },
                {
                  path: "snapshot",
                  component: () =>
                    import(
                      /* webpackChunkName: "net-finder.network.snapshot" */ "./views/net-finder/network/Snapshot.vue"
                    ),
                },
                {
                  path: "snapshot/:snapshotId",
                  component: () =>
                    import(
                      /* webpackChunkName: "net-finder.network.snapshot-top" */ "./views/net-finder/network/SnapshotTop.vue"
                    ),
                },
                {
                  path: "snapshot/:snapshotId/node",
                  component: () =>
                    import(
                      /* webpackChunkName: "net-finder.network.snapshot-node" */ "./views/net-finder/network/SnapshotNode.vue"
                    ),
                },
                {
                  path: "snapshot/:snapshotId/node/:nodeId",
                  component: () =>
                    import(
                      /* webpackChunkName: "net-finder.network.snapshot-node-top" */ "./views/net-finder/network/SnapshotNodeTop.vue"
                    ),
                },
                {
                  path: "snapshot/:snapshotId/node/:nodeId/package",
                  component: () =>
                    import(
                      /* webpackChunkName: "net-finder.network.snapshot-node-package" */ "./views/net-finder/network/SnapshotNodePackage.vue"
                    ),
                },
                {
                  path: "snapshot/:snapshotId/node/:nodeId/windows-update",
                  component: () =>
                    import(
                      /* webpackChunkName: "net-finder.network.snapshot-node-windows-update" */ "./views/net-finder/network/SnapshotNodeWindowsUpdate.vue"
                    ),
                },
              ],
            },
            {
              path: "v-sensor",
              component: () =>
                import(
                  /* webpackChunkName: "net-finder.v-sensor" */ "./views/net-finder/VSensor.vue"
                ),
            },
            {
              path: "managed-node",
              component: () =>
                import(
                  /* webpackChunkName: "net-finder.managed-node" */ "./views/tele-manager/TeleworkManager.vue"
                ),
            },
            {
              path: "asset-management",
              component: () =>
                import(
                  /* webpackChunkName: "net-finder.asset-management" */ "./views/net-finder/AssetManagement.vue"
                ),
            },
          ],
        },
        {
          path: "vuln-tracker",
          component: () =>
            import(
              /* webpackChunkName: "vuln-tracker.frame" */ "./views/vuln-tracker/Frame.vue"
            ),
          children: [
            {
              path: "",
              redirect: "/vuln-tracker/top",
            },
            {
              path: "top",
              component: () =>
                import(
                  /* webpackChunkName: "vuln-tracker.top" */ "./views/vuln-tracker/Top.vue"
                ),
            },
            {
              path: "vulnerability",
              component: () =>
                import(
                  /* webpackChunkName: "vuln-tracker.vulnerability" */ "./views/vuln-tracker/Vulnerability.vue"
                ),
            },
            {
              path: "vulnerability/:cveId",
              component: () =>
                import(
                  /* webpackChunkName: "vuln-tracker.vulnerability.frame" */ "./views/vuln-tracker/vulnerability/Frame.vue"
                ),
              children: [
                {
                  path: "",
                  redirect: "/vuln-tracker/vulnerability/:cveId/managed-node",
                },
                {
                  path: "msrc",
                  component: () =>
                    import(
                      /* webpackChunkName: "vuln-tracker.vulnerability.msrc" */ "./views/vuln-tracker/vulnerability/MSRC.vue"
                    ),
                },
                {
                  path: "managed-node",
                  component: () =>
                    import(
                      /* webpackChunkName: "vuln-tracker.vulnerability.managed-node" */ "./views/vuln-tracker/vulnerability/ManagedNode.vue"
                    ),
                },
              ],
            },
            {
              path: "vulnerability-redhat",
              component: () =>
                import(
                  /* webpackChunkName: "vuln-tracker.vulnerability-redhat" */ "./views/vuln-tracker/VulnerabilityRedHat.vue"
                ),
            },
            {
              path: "vulnerability-redhat/:cveId",
              component: () =>
                import(
                  /* webpackChunkName: "vuln-tracker.vulnerability-redhat.frame" */ "./views/vuln-tracker/vulnerability-redhat/Frame.vue"
                ),
              children: [
                {
                  path: "",
                  redirect:
                    "/vuln-tracker/vulnerability-redhat/:cveId/managed-node",
                },
                {
                  path: "redhat",
                  component: () =>
                    import(
                      /* webpackChunkName: "vuln-tracker.vulnerability-redhat.redhat" */ "./views/vuln-tracker/vulnerability-redhat/RedHat.vue"
                    ),
                },
                {
                  path: "managed-node",
                  component: () =>
                    import(
                      /* webpackChunkName: "vuln-tracker.vulnerability-redhat.managed-node" */ "./views/vuln-tracker/vulnerability-redhat/ManagedNode.vue"
                    ),
                },
              ],
            },
            {
              path: "detected-node",
              component: () =>
                import(
                  /* webpackChunkName: "vuln-tracker.detected-node" */ "./views/vuln-tracker/DetectedManagedNode.vue"
                ),
            },
            {
              path: "windows-update",
              component: () =>
                import(
                  /* webpackChunkName: "vuln-tracker.windows-update" */ "./views/vuln-tracker/WindowsUpdate.vue"
                ),
            },
          ],
        },
        {
          path: "sys-monitor",
          component: () =>
            import(
              /* webpackChunkName: "sys-monitor.frame" */ "./views/sys-monitor/Frame.vue"
            ),
          children: [
            {
              path: "",
              redirect: "/sys-monitor/top",
            },
            {
              path: "top",
              component: () =>
                import(
                  /* webpackChunkName: "sys-monitor.top" */ "./views/sys-monitor/Top.vue"
                ),
            },
          ],
        },
        {
          path: "data-protect",
          component: () =>
            import(
              /* webpackChunkName: "data-protect.frame" */ "./views/data-protect/Frame.vue"
            ),
          children: [
            {
              path: "",
              redirect: "/data-protect/top",
            },
            {
              path: "top",
              component: () =>
                import(
                  /* webpackChunkName: "data-protect.top" */ "./views/data-protect/Top.vue"
                ),
            },
          ],
        },
        {
          path: "l2-blocker",
          component: () =>
            import(
              /* webpackChunkName: "l2-blocker.frame" */ "./views/l2-blocker/Frame.vue"
            ),
          children: [
            {
              path: "",
              redirect: "/l2-blocker/node-config",
            },
            {
              path: "node-config",
              component: () =>
                import(
                  /* webpackChunkName: "l2-blocker.node-config" */ "./views/l2-blocker/NodeConfig.vue"
                ),
            },
          ],
        },
        {
          path: "data-analyzer",
          component: () =>
            import(
              /* webpackChunkName: "data-analyzer.frame" */ "./views/data-analyzer/Frame.vue"
            ),
          children: [
            {
              path: "",
              redirect: "/data-analyzer/top",
            },
            {
              path: "top",
              component: () =>
                import(
                  /* webpackChunkName: "data-analyzer.top" */ "./views/data-analyzer/Top.vue"
                ),
            },
          ],
        },
        {
          path: "support",
          component: () =>
            import(
              /* webpackChunkName: "support.frame" */ "./views/support/Frame.vue"
            ),
          children: [
            {
              path: "",
              redirect: "/support/inquiry",
            },
            {
              path: "inquiry",
              component: () =>
                import(
                  /* webpackChunkName: "support.inquiry" */ "./views/support/Inquiry.vue"
                ),
            },
            {
              path: "download",
              component: () =>
                import(
                  /* webpackChunkName: "support.download" */ "./views/support/Download.vue"
                ),
            },
          ],
        },
        {
          path: "membership",
          component: () =>
            import(
              /* webpackChunkName: "membership.frame" */ "./views/membership/Frame.vue"
            ),
          children: [
            {
              path: "",
              redirect: "/membership/employee",
            },
            {
              path: "employee",
              component: () =>
                import(
                  /* webpackChunkName: "membership.employee" */ "./views/membership/Employee.vue"
                ),
            },
            {
              path: "employee/:employeeId",
              component: () =>
                import(
                  /* webpackChunkName: "membership.employee-top" */ "./views/membership/EmployeeTop.vue"
                ),
            },
            {
              path: "import",
              component: () =>
                import(
                  /* webpackChunkName: "membership.import.frame" */ "./views/membership/import/Frame.vue"
                ),
              children: [
                {
                  path: "employee",
                  component: () =>
                    import(
                      /* webpackChunkName: "membership.import.employee" */ "./views/membership/import/Employee.vue"
                    ),
                },
              ],
            },
            {
              path: "account",
              component: () =>
                import(
                  /* webpackChunkName: "membership.account.frame" */ "./views/membership/account/Frame.vue"
                ),
              children: [
                {
                  path: "",
                  redirect: "/membership/account/account",
                },
                {
                  path: "account",
                  component: () =>
                    import(
                      /* webpackChunkName: "membership.account.account" */ "./views/membership/account/Account.vue"
                    ),
                },
                {
                  path: ":accountId/privilege",
                  component: () =>
                    import(
                      /* webpackChunkName: "membership.account.privilege" */ "./views/membership/account/Privilege.vue"
                    ),
                },
              ],
            },
          ],
        },
        {
          path: "joint",
          component: () =>
            import(
              /* webpackChunkName: "joint.frame" */ "./views/joint/Frame.vue"
            ),
          children: [
            {
              path: "",
              redirect: "/joint/ad-get-users",
            },
            {
              path: "ad-get-users",
              component: () =>
                import(
                  /* webpackChunkName: "joint.ad-get-users" */ "./views/joint/ADGetUsers.vue"
                ),
            },
          ],
        },
        {
          path: "sso",
          component: () =>
            import(/* webpackChunkName: "sso.frame" */ "./views/sso/Frame.vue"),
          children: [
            {
              path: "",
              redirect: "/sso/status",
            },
            {
              path: "status",
              component: () =>
                import(
                  /* webpackChunkName: "sso.status" */ "./views/sso/Status.vue"
                ),
            },
            {
              path: "user",
              component: () =>
                import(
                  /* webpackChunkName: "sso.user" */ "./views/sso/User.vue"
                ),
            },
            {
              path: "audit-log",
              component: () =>
                import(
                  /* webpackChunkName: "sso.audit-log" */ "./views/sso/AuditLog.vue"
                ),
            },
            {
              path: "download",
              component: () =>
                import(
                  /* webpackChunkName: "sso.download" */ "./views/sso/Download.vue"
                ),
            },
            {
              path: "inquiry",
              component: () =>
                import(
                  /* webpackChunkName: "sso.inquiry" */ "./views/sso/Inquiry.vue"
                ),
            },
          ],
        },
      ],
    },
    {
      path: "/login",
      props: (route) => ({
        redirect:
          typeof route.query.redirect === "string" ? route.query.redirect : "/",
      }),
      component: () =>
        import(/* webpackChunkName: "login" */ "./views/Login.vue"),
      beforeEnter: async (to, _from, next) => {
        // eslint-disable-next-line
        if (await isAuthorized(to.query.boardId).catch((_err) => false)) {
          if (!to.query.boardId) {
            to.query.boardId = AuthModule.currentBoard
              ? AuthModule.currentBoard.id
              : "";
            return next({ path: "/", query: to.query });
          } else {
            next();
          }
        }
        return next();
      },
    },
    {
      path: "/reset-password",
      component: () =>
        import(
          /* webpackChunkName: "reset-password" */ "./views/ResetPassword.vue"
        ),
    },
    {
      path: "*",
      component: () =>
        import(/* webpackChunkName: "notFound" */ "./views/NotFound.vue"),
    },
  ],
  // eslint-disable-next-line
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
      };
    } else {
      return { x: 0, y: 0 };
    }
  },
});

const isAuthorized = async (boardId: string | any) => {
  if (!AuthModule.user) await AuthModule.fetchUser();
  if (!AuthModule.boardList) await AuthModule.fetchBoardList();
  if (!AuthModule.currentBoard)
    AuthModule.SetCurrentBoard({
      id: typeof boardId === "string" ? boardId : "",
    });
  return (
    !!AuthModule.user && !!AuthModule.boardList && !!AuthModule.currentBoard
  );
};

router.beforeEach(async (to, _from, next) => {
  if (!to.matched.some((record) => record.meta.requiresAuth)) return next();

  // eslint-disable-next-line
  if (await isAuthorized(to.query.boardId).catch((_err) => false)) {
    if (!to.query.boardId) {
      to.query.boardId = AuthModule.currentBoard
        ? AuthModule.currentBoard.id
        : "";
      return next({ path: to.path, query: to.query, hash: to.hash });
    } else {
      return next();
    }
  }

  if (!to.query.redirect) {
    to.query.redirect = to.fullPath;
    return next({ path: "/login", query: to.query });
  } else {
    return next();
  }
});

export default router;
